const FUEL = {
  D: "Diesel",
  G: "Gasolina",
  E: "Elétrico"
};

const FUEL_REVERT = {
  "Diesel": "D",
  "Gasolina": "G",
  "Elétrico": "E"
};

export { FUEL, FUEL_REVERT };
